export default function RegionalIcon() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="20"
      height="18"
      viewBox="0 0 20 18"
      fill="none"
    >
      <path
        d="M13 3.75L19 2.25V15.75L13 17.25M13 3.75L7 0.75M13 3.75V17.25M13 17.25L7 14.25M7 14.25V0.75M7 14.25L1 15.75V2.25L7 0.75"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}
